import { Icon, IconProps } from "../Icon";

const ArrowUpLeft = (props: IconProps) => (
  <Icon {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 6V8H9.41L26 24.59L24.59 26L8 9.41V22H6V6H22Z"
      fill="currentColor"
    />
  </Icon>
);

export default ArrowUpLeft;
